const SignOutSvg = () => {
    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 2.5H15C15.5304 2.5 16.0391 2.71071 16.4142 3.08579C16.7893 3.46086 17 3.96957 17 4.5V6.5H15V4.5H6V20.5H15V18.5H17V20.5C17 21.0304 16.7893 21.5391 16.4142 21.9142C16.0391 22.2893 15.5304 22.5 15 22.5H6C5.46957 22.5 4.96086 22.2893 4.58579 21.9142C4.21071 21.5391 4 21.0304 4 20.5V4.5C4 3.96957 4.21071 3.46086 4.58579 3.08579C4.96086 2.71071 5.46957 2.5 6 2.5Z" fill="#545556" />
            <path d="M16.09 16.09L17.5 17.5L22.5 12.5L17.5 7.5L16.09 8.91L18.67 11.5H9V13.5H18.67L16.09 16.09Z" fill="#545556" />
        </svg>
    )
}

export default SignOutSvg;